import React from 'react';
import {versionSort} from '../common/arraySort';
import FilterTable from './filterTable';

const TrialLicenseTable = props => {
  const columns = [{
    dataField: 'device.key',
    text: 'Device key',
    sort: true,
    filter_: { type: 'text' }
  }, {
    dataField: 'productName',
    text: 'Product name',
    sort: true,
    filter_: { type: 'text' }
  }, {
    dataField: 'productVersion',
    text: 'Product version',
    sort: true,
    filter_: { type: 'text' },
    sortFunc: (a, b, order) => versionSort(2, a, b, order)
  }, {
    dataField: 'registerDateTime',
    text: 'Registration date and time',
    sort: true,
    filter_: {type: 'datetime'}
  }, {
    dataField: 'expirationDateTime',
    text: 'Expiration date and time',
    sort: true,
    filter_: {type: 'datetime'}
  }];

  const defaultSorted = [{
    dataField: 'registerDateTime',
    order: 'desc'
  }];

  return (
    <FilterTable
      {...props}
      objectName={'trialLicenses'}
      data={props.trialLicenses}
      columns={columns}
      defaultSorted={defaultSorted}
      noDataIndication="There are no trial licenses"
    />
  );
};

export default TrialLicenseTable;



// WEBPACK FOOTER //
// ./src/components/trialLicenseTable.js